import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { maskKey } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { CopyButton } from "@/components/agent/ui";

export const ApiHint = () => (
  <p className="text-xs text-muted-foreground" data-testid="api-example">
    Send it as <code>Authorization: Bearer</code> on <code>POST /api/v1/lets</code>.
  </p>
);

export const SecretKey = () => {
  const [key, setKey] = useState("");
  const [shown, setShown] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    api.get("/agent/api-key").then((r) => setKey(r.data.api_key)).catch((err) => setError(errorText(err)));
  }, []);
  if (error) return <p className="text-sm text-destructive" data-testid="secret-key-error">{error}</p>;
  return (
    <div className="flex flex-col gap-2" data-testid="secret-key">
      <div className="flex items-center gap-1">
        <code className="min-w-0 flex-1 truncate rounded-md border bg-panel px-2.5 py-1.5 font-mono text-xs" data-testid="secret-key-value">
          {key ? (shown ? key : maskKey(key)) : "Loading…"}
        </code>
        {key && <CopyButton value={key} label="Secret key copied" testid="secret-key-copy" />}
        <Button variant="ghost" size="icon-sm" className="text-muted-foreground" disabled={!key} onClick={() => setShown(!shown)}
          aria-label={shown ? "Hide secret key" : "Reveal secret key"} data-testid="secret-key-reveal">
          {shown ? <EyeOff /> : <Eye />}
        </Button>
      </div>
      <ApiHint />
    </div>
  );
};
